import { borderRadius, Tooltip } from '@toggle/design-system';
import styled from 'styled-components';

export const StyledTooltip = styled(Tooltip)`
  ${borderRadius.r2}
  padding: 8px;
  min-width: 275px;
  background-color: var(--surface-active);

  ${Tooltip.Styled.ArrowIcon} {
    background-color: var(--surface-active);
  }
`;

export const StyledBubble = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
